const BannerTypes = {
    GET_BANNERS: "GET_BANNERS",
    GET_BANNERS_SUCCESS: "GET_BANNERS_SUCCESS",
};

export { BannerTypes };
